<template>
  <div class="container">
    <a-select v-model="chooseValue"
      mode="multiple"
      style="width: 100%"
      placeholder="选择模板号"
      option-label-prop="label">
      <a-select-option :value="'T:' + item.tempCode"
        :label="item.tempCode"
        v-for="(item, index) in optionList"
        :key="index">
        <a-tag color="orange">
          模板号:
          {{ item.tempCode }}
        </a-tag>
        <a-tag color="cyan">
          模板名:
          {{ item.tempName }}
        </a-tag>
      </a-select-option>
    </a-select>
    <div class="closeButton">
      <a-button style="margin-right: 3%"
        @click="doClose()">关闭</a-button>
      <a-button type="primary"
        @click="sumitUpdate()"> 提交 </a-button>
    </div>
  </div>
</template>

<script>
import { getTemplateCodeSelectOption, updateUserCanUseTemplate } from '@/api/api'
import { getAction } from '@/api/manage'
export default {
  props: {
    dealRecord: {},
  },
  data() {
    return {
      width: 800,
      visible: false,
      chooseValue: [],
      optionList: [],
      confirmLoading: false,
      recordDate: {},
    }
  },
  watch: {
    dealRecord: {
      deep: true,
      handler() {
        this.updateRecordDate()
      },
    },
  },
  mounted() {
    this.getSelect()
    this.updateRecordDate()
  },
  methods: {
    updateRecordDate() {
      if (this.dealRecord != null) {
        this.recordDate = this.dealRecord
        this.initUserCanUseInfo()
      }
    },
    initUserCanUseInfo() {
      if (this.recordDate.canUseTemplate != null) {
        this.chooseValue = this.recordDate.canUseTemplate.split(',')
      } else {
        this.chooseValue = []
      }
    },
    getSelect() {
      getAction('/base/busCommonMessageTemplateNew/getAllTempNameAndCode', {}).then(res => {
        if (res.success) {
          this.optionList = res.result
        } else {
          this.$message.error(res.message)
        }
      })
      // getTemplateCodeSelectOption().then((res) => {
      //   if (res.success) {
      //     this.optionList = res.result
      //   } else {
      //     this.$message.error(res.message)
      //   }
      // })
    },
    sumitUpdate() {
      let queryParams = {
        templateCodes: this.chooseValue.join(','),
        tokenUserId: this.recordDate.id,
      }
      updateUserCanUseTemplate(queryParams).then((res) => {
        if (res.success) {
          this.$message.success('更新成功')
          this.doClose()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    doClose() {
      this.$emit('closeModel', false)
    },
  },
}
</script>


<style scoped>
.closeButton {
  height: 100%;
  margin-top: 3%;
  text-align: right;
}
.container {
  height: 100%;
}
</style>
